(function () {

  let currentSlide = 0;
  let sliderWrapper = null;

  const allVariants = window.productVariants || [];
  const productOptions = window.productOptions || [];
  const allImages = window.productImages || [];

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    sliderWrapper = document.getElementById('heroSlider');

    bindSliderNav();
    bindThumbnails();
    bindColorSwatches();
    bindQuantity();
    bindAddToCart();
    bindSwipe();
    toggleAQIByAirType();
    initMobileSlider();
    bindPincodeCheck();
    // 🔥 SET DEFAULT AMAZON LINK ON PAGE LOAD
setTimeout(() => {
  const activeColor = document.querySelector('.color-swatch.active')?.dataset.color;
  const activeAir = document.querySelector('.airtype-btn.active')?.dataset.airtype;

  const variant = findVariant(activeColor, activeAir);

  if (variant) {
    updatePageForVariant(variant);
  }
}, 100);
  }

  /* ============================
      SLIDER
  ============================ */

  function getSlides() {
    return document.querySelectorAll('#heroSlider .slide-img');
  }

  function updateSlider() {
    if (!sliderWrapper) return;
    sliderWrapper.style.transform =
      `translateX(-${currentSlide * 100}%)`;
  }

  function changeSlide(direction) {
    const slides = getSlides();
    if (!slides.length) return;

    currentSlide =
      (currentSlide + direction + slides.length) % slides.length;

    updateSlider();
  }

  function switchImage(index) {
    currentSlide = index;
    updateSlider();

    document.querySelectorAll('.thumb-box')
      .forEach((t, i) => {
        t.classList.toggle('active', i === index);
      });
  }

  function bindSliderNav() {
    document.querySelectorAll('.slider-nav')
      .forEach(btn => {
        btn.addEventListener('click', function () {
          const dir = parseInt(this.dataset.direction);
          changeSlide(dir);
        });
      });
  }

  function bindThumbnails() {
    document.addEventListener('click', function (e) {
      const thumb = e.target.closest('.thumb-box');
      if (!thumb) return;

      const index = parseInt(thumb.dataset.index);
      switchImage(index);
    });
  }
function bindPincodeCheck() {

  const input = document.querySelector('.pincode-input');
  const btn = document.getElementById('pincode-apply');

  const success = document.querySelector('.pincode-success');
  const error = document.querySelector('.pincode-error');
  const invalid = document.querySelector('.pincode-invalid');

  if (!input || !btn) return;

  btn.addEventListener('click', function () {

    const pin = input.value.trim();

    // reset all
    success.style.display = 'none';
    error.style.display = 'none';
    invalid.style.display = 'none';

    // ✅ only validation
    if (!/^[0-9]{6}$/.test(pin)) {
      invalid.style.display = 'block';
      return;
    }

    // ✅ always success (India-wide delivery)
    success.style.display = 'block';

  });
}

  /* ============================
      VARIANT SYSTEM
  ============================ */

  function getVariantOptionsMap(variant) {
    const map = {};
    productOptions.forEach((opt, index) => {
      map[opt.name.toLowerCase()] =
        variant[`option${index + 1}`];
    });
    return map;
  }

function findVariant(color, airtype) {
  return allVariants.find((variant) => {
    const opts = getVariantOptionsMap(variant);

    const colorMatch =
      !color ||
      (opts.color &&
        opts.color.toLowerCase() === color.toLowerCase());

    const airKey = Object.keys(opts).find(k =>
      k.includes('air')
    );

    const airMatch =
      !airtype ||
      (airKey &&
        opts[airKey]?.toLowerCase() === airtype.toLowerCase());

    return colorMatch && airMatch;
  });
}


 function updatePageForVariant(variant) {
  if (!variant) return;

  /* =========================
     UPDATE ALL VARIANT IDS
  ========================= */

  document.querySelectorAll('input[name="id"]')
    .forEach(input => input.value = variant.id);

  document.querySelectorAll('.cart-btn, .mobile-add-btn')
    .forEach(btn => btn.dataset.variantId = variant.id);

  document.querySelectorAll('#mobileVariantId')
    .forEach(el => el.value = variant.id);

  /* =========================
     UPDATE PRICE (ALL)
  ========================= */

  const formattedPrice =
    '₹' + (variant.price / 100).toLocaleString();

  document.querySelectorAll('.current-price')
    .forEach(el => el.textContent = formattedPrice);

  const hasCompare =
    variant.compare_at_price &&
    variant.compare_at_price > variant.price;

  document.querySelectorAll('.compare-price')
    .forEach(el => {
      if (hasCompare) {
        el.textContent =
          '₹' + (variant.compare_at_price / 100).toLocaleString();
        el.style.display = 'inline';
      } else {
        el.style.display = 'none';
      }
    });

  document.querySelectorAll('.discount')
    .forEach(el => {
      if (hasCompare) {
        const savings =
          variant.compare_at_price - variant.price;

        el.textContent =
          'Save Rs. ' +
          (savings / 100).toLocaleString();

        el.style.display = 'inline-block';
      } else {
        el.style.display = 'none';
      }
    });
   // 🔥 UPDATE AMAZON LINK BASED ON VARIANT
        const amazonBtn = document.getElementById("amazonBtn");

if (amazonBtn && variant) {
  const opts = getVariantOptionsMap(variant);

  const airValue = Object.values(opts).find(v =>
    v?.toLowerCase().includes("purifier")
  );

  if (!airValue) return;

  const value = airValue.toLowerCase();

  if (value.includes("without")) {
    amazonBtn.href = "https://www.amazon.in/KARBAN-Airzone-Smart-Bladeless-ceiling/dp/B0G3X4KTPJ";
  } else if (value.includes("with")) {
    amazonBtn.href = "https://www.amazon.in/KARBAN-Airzone-Smart-Bladeless-ceiling/dp/B0G3X7S73Y";
  }

  /* =========================
   UPDATE HEADING + DESC
========================= */

}
const headings = document.querySelectorAll('[data-heading-with]');
const descs = document.querySelectorAll('[data-desc-with]');

const opts = getVariantOptionsMap(variant);

const airValue = Object.values(opts).find(v =>
  v?.toLowerCase().includes("with") || v?.toLowerCase().includes("without")
);

if (airValue) {
  const isWithout = airValue.toLowerCase().includes("without");

  headings.forEach(el => {
    el.textContent = isWithout
      ? el.dataset.headingWithout
      : el.dataset.headingWith;
  });

  descs.forEach(el => {
    el.textContent = isWithout
      ? el.dataset.descWithout
      : el.dataset.descWith;
  });
}


  /* =========================
     UPDATE IMAGES
  ========================= */

  rebuildImages(variant);

  document.dispatchEvent(
    new CustomEvent('variant:changed', {
      detail: variant
    })
  );
}


function rebuildImages(variant) {

  /* ========================
     DESKTOP SLIDER
  ======================== */

  const heroSlider = document.getElementById('heroSlider');
  const thumbStrip = document.getElementById('thumbStrip');

  const selectedColor = (variant.option1 || '').toLowerCase();

  let images = allImages.filter(img =>
    img.toLowerCase().includes(selectedColor)
  );

  if (!images.length && variant.featured_image?.src) {
    images = [variant.featured_image.src];
  }

  /* DESKTOP */
  if (heroSlider && thumbStrip) {

    heroSlider.innerHTML = '';
    thumbStrip.innerHTML = '';

    images.forEach((img, index) => {

      heroSlider.insertAdjacentHTML(
        'beforeend',
        `<div class="slide-img">
           <img src="${img}" loading="${index === 0 ? 'eager' : 'lazy'}">
         </div>`
      );

      thumbStrip.insertAdjacentHTML(
        'beforeend',
        `<div class="thumb-box ${index === 0 ? 'active' : ''}"
             data-index="${index}">
           <img class="thumb-img" src="${img}">
         </div>`
      );
    });

    currentSlide = 0;
    updateSlider();
  }

  /* ========================
     MOBILE SLIDER
  ======================== */

  const mobileSlider = document.getElementById('mobileHeroSlider');
  const mobileDotsContainer = document.querySelector('.mobile-slider-dots');

  if (mobileSlider && mobileDotsContainer) {

    mobileSlider.innerHTML = '';
    mobileDotsContainer.innerHTML = '';

    images.forEach((img, index) => {

      mobileSlider.insertAdjacentHTML(
        'beforeend',
        `<div class="mobile-slide">
           <img src="${img}" loading="lazy">
         </div>`
      );

      mobileDotsContainer.insertAdjacentHTML(
        'beforeend',
        `<span class="mobile-dot ${index === 0 ? 'active' : ''}"
               data-index="${index}"></span>`
      );

    });

    /* Reinitialize mobile slider */
    setTimeout(() => {
      if (typeof initMobileSlider === "function") {
        initMobileSlider();
      }
    }, 50);
  }
}

function bindColorSwatches() {

  const swatches =
    document.querySelectorAll('.color-swatch');

  const airBtns =
    document.querySelectorAll('.airtype-btn');

  function getActiveColor() {
    const active =
      document.querySelector('.color-swatch.active');
    return active?.dataset.color || '';
  }

  function getActiveAirtype() {
    const active =
      document.querySelector('.airtype-btn.active');
    return active?.dataset.airtype || '';
  }

  function refreshVariant() {
    const variant = findVariant(
      getActiveColor(),
      getActiveAirtype()
    );

    updatePageForVariant(variant);
  }

  /* COLOR CLICK */
  swatches.forEach(swatch => {
    swatch.addEventListener('click', function () {
      swatches.forEach(s =>
        s.classList.remove('active'));

      this.classList.add('active');

      refreshVariant();
    });
  });

  /* AIRTYPE CLICK */
  airBtns.forEach(btn => {
    btn.addEventListener('click', function () {
      airBtns.forEach(b =>
        b.classList.remove('active'));

      this.classList.add('active');

      refreshVariant();
      toggleAQIByAirType();
    });
  });

}


  /* ============================
      QUANTITY
  ============================ */

  function bindQuantity() {
    const minus = document.querySelector('.qty-minus');
    const plus = document.querySelector('.qty-plus');
    const input = document.getElementById('quantity');
    const finalQty =
      document.getElementById('finalQty');

    if (!input) return;

    function update(change) {
      let val = parseInt(input.value) || 1;
      val += change;
      if (val < 1) val = 1;
      input.value = val;
      if (finalQty) finalQty.value = val;
    }

    minus?.addEventListener('click', () => update(-1));
    plus?.addEventListener('click', () => update(1));
  }
  function bindMobileDots() {
  const dots = document.querySelectorAll('.mobile-dot');

  dots.forEach(dot => {
    dot.addEventListener('click', function () {

      const index = parseInt(this.dataset.index);
      currentSlide = index;
      updateSlider();

      dots.forEach(d => d.classList.remove('active'));
      this.classList.add('active');

    });
  });
}


  /* ============================
      ADD TO CART
  ============================ */
function bindAddToCart() {

  document.addEventListener('click', function(e) {

    const btn = e.target.closest('.cart-btn, .mobile-add-btn');
    if (!btn) return;

    const variantId = +btn.dataset.variantId;

    let qty = 1;

    if (btn.classList.contains('mobile-add-btn')) {
      qty = +(document.getElementById('mobileQuantity')?.value || 1);
    } else {
      qty = +(document.getElementById('quantity')?.value || 1);
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: qty
      }),
    })
    .then(() => {
      return fetch(`${window.location.pathname}?section_id=cart-drawer`);
    })
    .then(res => res.text())
    .then(html => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newDrawer = doc.querySelector('cart-drawer');
      const oldDrawer = document.querySelector('cart-drawer');

      if (oldDrawer && newDrawer) {
        oldDrawer.replaceWith(newDrawer);
        newDrawer.open();
      }
    });

  });

}

  /* ============================
      SWIPE
  ============================ */

  function bindSwipe() {
    const slider =
      document.querySelector('.hero-image-slider');
    if (!slider) return;

    let startX = 0;

    slider.addEventListener('touchstart', e => {
      startX = e.touches[0].clientX;
    }, { passive: true });

    slider.addEventListener('touchend', e => {
      const diff =
        e.changedTouches[0].clientX - startX;

      if (diff > 50) changeSlide(-1);
      if (diff < -50) changeSlide(1);
    }, { passive: true });
  }

  /* ============================
      AQI TOGGLE
  ============================ */

  function toggleAQIByAirType() {
    const activeBtn =
      document.querySelector('.airtype-btn.active');
    const aqiEl =
      document.querySelector('.aqi-feature');

    if (!aqiEl) return;

    if (
      activeBtn &&
      activeBtn.dataset.airtype
        ?.toLowerCase()
        .includes('without')
    ) {
      aqiEl.classList.add('is-hidden');
    } else {
      aqiEl.classList.remove('is-hidden');
    }
  }

})();
function initMobileSlider() {

  const mobileSlider = document.getElementById('mobileHeroSlider');
  if (!mobileSlider) return;

  let mobileIndex = 0;
  const slides = mobileSlider.querySelectorAll('.mobile-slide');
  const dots = document.querySelectorAll('.mobile-dot');

  const maxVisibleDots = 5;
  let startX = 0;
  let endX = 0;

  function updateDots() {

    dots.forEach(dot => dot.style.display = 'none');

    let start = Math.max(0, mobileIndex - 2);
    let end = Math.min(slides.length, start + maxVisibleDots);

    if (end - start < maxVisibleDots) {
      start = Math.max(0, end - maxVisibleDots);
    }

    for (let i = start; i < end; i++) {
      dots[i].style.display = 'inline-block';
      dots[i].classList.toggle('active', i === mobileIndex);
    }
  }

  function update() {
    mobileSlider.style.transform =
      `translateX(-${mobileIndex * 100}%)`;
    updateDots();
  }

  window.changeMobileSlide = function(direction) {
    mobileIndex =
      (mobileIndex + direction + slides.length) % slides.length;
    update();
  }

  /* DOT CLICK */
  dots.forEach(dot => {
    dot.addEventListener('click', function () {
      mobileIndex = parseInt(this.dataset.index);
      update();
    });
  });

  /* 🔥 SWIPE SUPPORT */
  mobileSlider.addEventListener('touchstart', function(e) {
    startX = e.touches[0].clientX;
  }, { passive: true });
  mobileSlider.addEventListener('touchend', function(e) {
    endX = e.changedTouches[0].clientX;
    handleSwipe();
  }, { passive: true });

  function handleSwipe() {
    const diff = startX - endX;

    if (Math.abs(diff) < 50) return; // ignore small swipes

    if (diff > 0) {
      // swipe left
      mobileIndex =
        (mobileIndex + 1) % slides.length;
    } else {
      // swipe right
      mobileIndex =
        (mobileIndex - 1 + slides.length) % slides.length;
    }

    update();
  }

  update();
}

function updateMobileQuantity(change) {
  const qtyInput = document.getElementById("mobileQuantity");
  const hiddenQty = document.getElementById("mobileFinalQty");

  let current = parseInt(qtyInput.value) || 1;
  current += change;

  if (current < 1) current = 1;

  qtyInput.value = current;
  hiddenQty.value = current;
}
function updateMobileVariant(variantId) {
  const mobileInput = document.getElementById("mobileVariantId");
  if (mobileInput) mobileInput.value = variantId;

  const mobileBtn = document.querySelector(".mobile-add-btn");
  if (mobileBtn) mobileBtn.dataset.variantId = variantId;
}

function updateQuantity(change) {
  const qtyInput = document.getElementById("quantity");
  const hiddenQty = document.getElementById("finalQty");

  if (!qtyInput) return;

  let current = parseInt(qtyInput.value) || 1;
  current += change;

  if (current < 1) current = 1;

  qtyInput.value = current;

  if (hiddenQty) hiddenQty.value = current;
} 